// src/pages/Tentovye.js
import React, { useState } from 'react';
import CountUp from 'react-countup';
import './Tentovye.css';

const Tentovye = () => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [responseMsg, setResponseMsg] = useState('');

  // Обработчик ввода данных в форму
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('http://localhost:5000/api/requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, tab: 'tentovye' }),
      });
      const data = await response.json();
      if (response.ok) {
        setResponseMsg(data.message || 'Заявка успешно отправлена!');
        setFormData({ name: '', phone: '' });
      } else {
        setResponseMsg(data.message || 'Ошибка при отправке');
      }
    } catch (err) {
      console.error(err);
      setResponseMsg('Ошибка подключения к серверу');
    }
  };

  return (
    <div className="tentovye-page">
      {/* Шапка страницы */}
      <header className="tentovye-header">
        <div className="header-overlay">
          <h1>Контейнеровозы</h1>
        </div>
      </header>
      {/* Отступ с белым фоном между блоками */}
<div className="section-spacing-white"></div>

      {/* Секция "Форма заявки" */}
      <section className="tentovye-request">
        <div className="container">
          <h2>Оставьте заявку!</h2>
          <p>Наш менеджер свяжется с вами для уточнения всех деталей</p>
          <form className="request-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Ваше имя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Ваш телефон"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <button type="submit">Отправить заявку</button>
          </form>
          {responseMsg && <p className="response-message">{responseMsg}</p>}
          <p className="disclaimer">
            Нажимая на кнопку, вы соглашаетесь на обработку персональных данных
          </p>
        </div>
      </section>
      {/* Информационная секция */}
      <section className="tentovye-info">
        <div className="container">
          <h2>Что такое перевозки контейнеровозами?</h2>
          <p>
            Перевозки контейнеровозами — это транспортировка грузов в стандартных контейнерах с использованием специализированных транспортных средств, предназначенных для безопасной и эффективной доставки. Такой способ обеспечивает максимальную сохранность груза, упрощает логистику и ускоряет процессы погрузки и выгрузки.
          </p>
        </div>
      </section>
      <section class="info-section icon-type">
  <div class="info-container">
    <h2>Поддерживаемые типы контейнеров</h2>
    <p>
      Мы осуществляем перевозки стандартных контейнеров различных типов:
      <ul>
        <li>20-футовые контейнеры</li>
        <li>40-футовые контейнеры</li>
        <li>45-футовые контейнеры</li>
      </ul>
      Наш автопарк адаптирован под любые габариты и обеспечивает надёжную фиксацию груза.
    </p>
  </div>
</section>
      <section class="info-section icon-route">
  <div class="info-container">
    <h2>Маршруты перевозки</h2>
    <p>
      Доставляем грузы по всей России, в том числе:
      <ul>
        <li>Москва и область</li>
        <li>Санкт-Петербург</li>
        <li>Ростов-на-Дону</li>
        <li>Архангельск, Пермь, Омск</li>
      </ul>
      Маршруты выстраиваются индивидуально под клиента с учётом логистики и сроков.
    </p>
  </div>
</section>
<section class="info-section icon-service">
  <div class="info-container">
    <h2>Наши преимущества</h2>
    <p>
      Почему выбирают нас:
      <ul>
        <li>Опытные водители с аккредитацией</li>
        <li>Собственный автопарк</li>
        <li>Охраняемая территория 24/7</li>
        <li>Гибкие тарифы и страхование грузов</li>
      </ul>
    </p>
  </div>
</section>
<section class="info-section icon-truck">
  <div class="info-container">
    <h2>Параметры контейнеровозов</h2>
    <p>
      Все машины проходят регулярный техосмотр и оснащены:
      <ul>
        <li>Системой крепления контейнеров</li>
        <li>GPS-мониторингом в реальном времени</li>
        <li>Допусками к опасным и негабаритным грузам</li>
      </ul>
    </p>
  </div>
</section>


      {/* Секция с особенностями как карточки */}
      <section className="tentovye-features">
        <div className="container">
          <h2>Основные особенности</h2>
          <div className="feature-cards">
            <div className="feature-card card-protection">Надёжная защита</div>
            <div className="feature-card card-universal">Универсальность</div>
            <div className="feature-card card-fast">Быстрая погрузка</div>
          </div>
        </div>
      </section>

      {/* Секция "Наши преимущества" */}
      <section className="tentovye-advantages">
        <div className="container">
          <h2>Наши преимущества</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Надежность</h3>
              <p>Используем качественные и проверенные транспортные средства.</p>
            </div>
            <div className="advantage-item">
              <h3>Скорость</h3>
              <p>Быстрая организация перевозок с минимальными задержками.</p>
            </div>
            <div className="advantage-item">
              <h3>Индивидуальный подход</h3>
              <p>Разработка маршрута с учётом особенностей вашего груза.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Секция "Схема работы" */}
      <section className="tentovye-scheme">
        <div className="container">
          <h2>Схема работы</h2>
          <div className="scheme-steps">
            <div className="scheme-step">
              <div className="scheme-icon step-icon-1"></div>
              <p>Принимаем заявку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-2"></div>
              <p>Планируем загрузку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-3"></div>
              <p>Организуем перевозку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-4"></div>
              <p>Выгружаем груз</p>
            </div>
          </div>
        </div>
      </section>
      <section className="contacts-section">
        <div className="container contacts-container">
          <div className="contacts-info">
            <div className="contact-item address">
              <span>Калужская область, Боровский район, п. Ворсино</span>
            </div>
            <div className="contact-item email">
              <span>amlogistic40@mail.ru</span>
            </div>
          </div>
        </div>
      </section>



    </div>
  );
};

export default Tentovye;
